"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const base_ui_text_heading_1 = require("@unboared/base-ui.text.heading");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
function Section(_a) {
    var { size = 20 } = _a, props = __rest(_a, ["size"]);
    const { text, tx, txOptions, children, style: styleOverride, textStyle: textStyleOverride } = props;
    // const theme = useTheme();
    // const currentTheme = (theme as Theme) || defaultTheme;
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const viewStyles = [styleOverride];
    const textStyles = [{ fontSize: normalize(size), fontFamily: 'MontserratBold' }, textStyleOverride];
    return (react_1.default.createElement(react_native_1.View, { style: viewStyles },
        react_1.default.createElement(react_native_1.View, { style: { marginVertical: 0.5 * normalize(size) } },
            react_1.default.createElement(base_ui_text_heading_1.Heading, { type: 'h2', tx: tx, text: text, txOptions: txOptions, style: textStyles })),
        children));
}
exports.Section = Section;
//# sourceMappingURL=section.js.map